import { styled } from '@mui/material/styles';

import TableSortLabel from "@mui/material/TableSortLabel";

const StyledTableSortLabel = styled(TableSortLabel)(
    () => ({
        '& .MuiTableSortLabel-icon': {
            marginLeft: 0,
            marginRight: 0,
        },
    })
);

export default StyledTableSortLabel;
